import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { initAxios } from './api/axiosConfig';
import './assets/font/inter.css';

initAxios();
const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </GoogleOAuthProvider>
);
